import React, { type ReactNode } from 'react'
import { Bleedable } from '@fs/zion-ui'
import useMergeMarginX from './useMergeMarginX'
import { type PersonType } from '../types/general'
import { useMergeIsMobile } from '../providers/MergeLayoutProvider'

/**
 * At mobile only the side facing a column divider gets padding, keeping the outer edges flush with the edge-to-edge
 * card text. The Final result shows at mobile only beside the Main person, its divider at its start.
 */
const MOBILE_DIVIDER_SIDE: Record<PersonType, 'paddingInlineEnd' | 'paddingInlineStart'> = {
  duplicate: 'paddingInlineEnd',
  resultant: 'paddingInlineStart',
  survivor: 'paddingInlineStart',
}

type Props = {
  children: ReactNode
  personType: PersonType
}

/** Side padding for the merge column headings. Bleedable only supports symmetric side padding, hence the css map for the asymmetric mobile case. */
export default function ColumnHeadingPadding({ children, personType }: Props): JSX.Element {
  const isMobile = useMergeIsMobile()
  const marginX = useMergeMarginX()

  if (isMobile) {
    return <div style={{ [MOBILE_DIVIDER_SIDE[personType]]: marginX }}>{children}</div>
  }

  return <Bleedable sides={4}>{children}</Bleedable>
}
